// extracted by mini-css-extract-plugin
export var footer = "_pi-0";
export var inherit = "_pi-1";
export var input = "_pi-2";
export var modalContent = "_pi-3";
export var quillEditor = "_pi-4";
export var subtitle = "_pi-5";